var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"padding":"4px 4px 0 4px","display":"inline-block","border":"solid 1px rgba(0, 0, 0, 0.1)"}},[_c('img',{staticStyle:{"opacity":"0.1"},attrs:{"src":_vm.src}})])])}
var staticRenderFns = []

export { render, staticRenderFns }